import { GetterTree } from 'vuex'

import { RootState } from '../types'
import { AppState } from './types'

const getters: GetterTree<AppState, RootState> = {
  searchParams: (state: AppState) => state.data.searchParams
}

export default getters
